var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import UniversalReport from '@tencent/universal-report';
import { stringify } from 'query-string';
import Cookies from 'js-cookie';
import DtSource from '@tencent/athena-dt-source';
export const APP_ID = 'JS0081LY3JY6J3';
export const PAGE_ID = 'page_user_center';
export var DtEvent;
(function (DtEvent) {
    DtEvent["IMP"] = "dt_imp";
    DtEvent["CLICK"] = "dt_clck";
    DtEvent["IMP_END"] = "dt_imp_end";
})(DtEvent || (DtEvent = {}));
export var DtModuleId;
(function (DtModuleId) {
    DtModuleId["HISTORY"] = "history";
    DtModuleId["FOLLOWING"] = "following";
    DtModuleId["SUBSCRIBE"] = "subscribe";
    DtModuleId["COLLECT"] = "collect";
    DtModuleId["RECOMMEND"] = "recommend";
})(DtModuleId || (DtModuleId = {}));
/**
 * 元素id 枚举
 */
export var DtEid;
(function (DtEid) {
    DtEid["POSTER"] = "poster";
    DtEid["BUTTON"] = "button";
    DtEid["CREATOR_PORTRAIT"] = "creator_portrait";
    DtEid["TAB"] = "tab";
})(DtEid || (DtEid = {}));
/**
 * 海报元素上报参数包
 * @param obj - 上报参数
 * @param currentCid - 当前的cid，用于计算rtype
 */
export function toDtPosterParams(obj) {
    let rtype = 'vid';
    if (obj.cid) {
        rtype = 'cid';
    }
    if (obj.lid) {
        rtype = 'lid';
    }
    return stringify(Object.assign(Object.assign({}, obj), { rtype }));
}
/**
 * 按钮参数包
 */
export function toDtButtonParams(obj) {
    return stringify(Object.assign({}, obj));
}
export function toDtCommonParams(obj) {
    return stringify(Object.assign({}, obj));
}
/**
 * 手动上报传参，透传，仅作为类型检查
 */
export function toDtMannualParams(obj) {
    return obj;
}
export var DtModTabId;
(function (DtModTabId) {
    /**
     * 主演tab
     */
    DtModTabId["STAR_TAB"] = "star_tab";
})(DtModTabId || (DtModTabId = {}));
function getGuidPromise() {
    return new Promise((resolve) => {
        txv.login.getGuid((data) => resolve(data));
    });
}
/**
 * 获取通用的公共参数
 */
function getPublicParams() {
    return __awaiter(this, void 0, void 0, function* () {
        let params = {
            vuserid: Cookies.get('vqq_vuserid') || Cookies.get('vuserid'),
            tab_experiment_id: Cookies.get('tab_experiment_id') || '',
            is_vip: -1,
            guid: '',
        };
        try {
            const [vipInfo, guid] = yield Promise.all([
                txv.vip.getVipInfo(),
                getGuidPromise(),
            ]);
            params.is_vip = vipInfo.vip;
            params.guid = guid;
        }
        catch (err) { }
        return Object.assign({}, params);
    });
}
function getAccountInfo() {
    const params = {
        dt_qqopenid_h5: Cookies.get('qq_openid'),
        dt_wxopenid_h5: Cookies.get('wx_openid'),
        dt_mainlogin_h5: Cookies.get('main_login') // 主登录类型
    };
    return Object.assign({}, params);
}
// 初始化页面跳转时的追踪来源库
function initDtSource() {
    DtSource.initDtSource({
        default_cre_pg: {
            pgid: PAGE_ID,
        },
        cur_pg: {
            pgid: PAGE_ID,
        },
    });
}
export function initReporter() {
    return __awaiter(this, void 0, void 0, function* () {
        const reporter = new UniversalReport({
            beacon: APP_ID,
            publicParams: yield getPublicParams(),
            accountInfo: getAccountInfo(),
        });
        window.reporter = reporter;
        initDtSource();
    });
}
